<template>
     <v-theme-provider dark>
          <base-section id="contact-us" class="primary" space="40">
               <v-container>
                    <v-row justify="center">
                         <v-col cols="10">
                              <base-title
                                   :space="$vuetify.breakpoint.mdAndUp ? 0 : 4"
                                   title="Yes! I do bulk orders."
                              />

                              <base-body space="0">
                                   <span class="white--text">
                                        Typically my work is created in small
                                        quantities. If you like what you've seen
                                        and need more than I have in stock just
                                        ask.
                                   </span>
                              </base-body>
                         </v-col>

                         <v-col cols="12" md="2" class="text-center">
                              <base-btn
                                   color="green"
                                   href="mailto:atibbetts@afksoftware.com?subject=Bulk%Order%Question"
                                   large
                                   target="_blank"
                              >
                                   Contact Us
                              </base-btn>
                         </v-col>
                    </v-row>
               </v-container>
          </base-section>
     </v-theme-provider>
</template>

<script>
export default {
     name: 'SectionContactUs',
}
</script>
